






































import {Vue, Component, Watch} from 'vue-property-decorator';
import Footer from '@/components/Views/Home Page/Footer.vue';
import FooterLinks from '@/components/Views/Home Page/FooterLinks.vue';
import HeroImage from '@/components/Views/Home Page/HeroImage.vue';
import PageWithSidebar from '@/components/Views/Home Page/PageWithSidebar.vue';
import {groupBy, keyBy} from 'lodash';
import ServiceListing from '@/components/Views/Home Page/ServiceListing.vue';
import {FeathersVuexFindAll} from '@/utils';
import ServicesPage from '@/components/Pages/Home Page/Services/ServicesPage.vue';

@Component({
    components: {
        ServicesPage,
        ServiceListing,
        PageWithSidebar,
        HeroImage,
        FooterLinks,
        Footer,
    },
})
export default class SpecialEvents extends Vue {
    private header = 'Special Events';
    private hero1 = 'Special Events';
    private hero2 = 'Award-Winning Beauty Pros Specializing in Everything from Red Carpet Events & Award Shows to TV & Film';
    private heroImage = require('@/assets/hero/special_events.jpg');
    private title = 'Hair Stylist & Makeup Services for Engagement Photos, Prom, Night on the Town & More!';
    private get crumbs() {
        const lastItem = this.isGalaAndAwardShows ? {name: 'Galas & Award Shows', path: '/services/events'} : {name: 'TV & Film', path: '/services/tv-and-film'};
        return [
            {name: 'Home', path: '/'},
            {name: 'Services', path: '/services'},
            lastItem,
        ];
    }
    public serviceQuery = null;
    public mounted() {
        this.setServiceQuery();
    }
    public async setServiceQuery() {
        const {ServiceType, Category} = this.$FeathersVuex;
        const serviceTypes = await FeathersVuexFindAll(ServiceType, {
        });
        const [category] = await FeathersVuexFindAll(Category, {
            query: {
                name: this.categoryName,
            },
        });
        this.serviceQuery = {
            serviceTypes: {$in: serviceTypes.map((x) => x._id)},
            category: category._id,
            $sort: {
                displayOrder: 1,
            },
        };
    }
    @Watch('isGalaAndAwardShows')
    public onIsGalaAndAwardShowsChanged(value: boolean, oldValue: boolean) {
        this.setServiceQuery();
    }
    public get isGalaAndAwardShows() {
        return this.$route.name === 'events';
    }
    public get categoryName() {
        return this.isGalaAndAwardShows ? 'Award Shows & Galas' : 'TV & Film';
    }
}
